import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      nameRules: [
        v => Rules.isRequired(v),
        v => Rules.minLength(v, 2),
        v => Rules.maxLength(v, 90)
      ],
      emailRules: [
        v => Rules.isRequired(v),
        v => Rules.isEmail(v)
      ],
      passwordRules: [
        v => Rules.isRequired(v),
        v => Rules.isPassword(v),
        v => Rules.maxLength(v, 30)

      ],
      userAuthClassRules: [
        v => Rules.isRequired(v)
      ]
    }
  }
}
